import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { App } from '@capacitor/app'

/**
 * Hook para gestionar la navegacion hacia atras al utilizar el retroceso del dispositivo mobile
 * @param {string} isMobileSystem - Booleano que indica si es una aplicacion mobile
 */
const useBackButtonNavigation = (isMobileSystem) => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (isMobileSystem) {
      const listener = App.addListener('backButton', () => {
      if (location.pathname === '/inicio' || location.pathname === 'login') {
        App.exitApp()
      } else history.goBack()
    })
    return () => listener.remove()
    }
    
  }, [history, location])
}

export default useBackButtonNavigation